import React from 'react';
import SectionMessage from '@atlaskit/section-message';
import { HelpContent } from '@css-xp/ppc-common';

export const InvalidEntitlementLinkMessage: React.FC<{ message?: string }> = ({ message }) => {
  return (
    <SectionMessage title="Not Allowed" appearance="error" testId="invalid-entitlement-link-message">
      <p className="not-allowed-message">
        <HelpContent
          contentPrefix={`${
            message ?? "This app isn't compatible with the selected product - try selecting another app. "
          } Still having trouble? Contact`}
        />
      </p>
    </SectionMessage>
  );
};
